import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { Button } from '../components/ui/Button';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-navy-900 min-h-screen" data-id="element-201">
      <PageHeader title="Contact Us" subtitle="Get in touch with our expert advisors to discuss your business, property, or legal requirements in Bali." backgroundImage="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80" data-id="element-202" />

      <section className="py-24" data-id="element-203">
        <div className="max-w-content mx-auto px-6 md:px-12" data-id="element-204">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-205">
            {/* Contact Information */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-206">
              <h2 className="font-display text-4xl font-bold text-white mb-6" data-id="element-207">
                Let's Discuss Your Strategy
              </h2>
              <p className="font-body text-gray-400 text-lg mb-12 leading-relaxed" data-id="element-208">
                Whether you are establishing a new PT PMA, seeking premium
                property management, or requiring comprehensive tax advisory,
                our team is ready to assist you.
              </p>

              <div className="space-y-8" data-id="element-209">
                <div className="flex items-start gap-6" data-id="element-210">
                  <div className="w-14 h-14 bg-navy-800 rounded-full flex items-center justify-center text-gold shrink-0 border border-navy-700" data-id="element-211">
                    <Phone size={24} data-id="element-212" />
                  </div>
                  <div data-id="element-213">
                    <h4 className="font-heading text-xl font-semibold text-white mb-2" data-id="element-214">
                      WhatsApp / Phone
                    </h4>
                    <a href="https://wa.me/6282326357189" className="font-body text-gray-400 hover:text-gold transition-colors text-lg" data-id="element-215">
                      +62 823-2635-7189
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-216">
                  <div className="w-14 h-14 bg-navy-800 rounded-full flex items-center justify-center text-gold shrink-0 border border-navy-700" data-id="element-217">
                    <Mail size={24} data-id="element-218" />
                  </div>
                  <div data-id="element-219">
                    <h4 className="font-heading text-xl font-semibold text-white mb-2" data-id="element-220">
                      Email
                    </h4>
                    <a href="mailto:marvestafinance@gmail.com" className="font-body text-gray-400 hover:text-gold transition-colors text-lg" data-id="element-221">
                      marvestafinance@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-222">
                  <div className="w-14 h-14 bg-navy-800 rounded-full flex items-center justify-center text-gold shrink-0 border border-navy-700" data-id="element-223">
                    <MapPin size={24} data-id="element-224" />
                  </div>
                  <div data-id="element-225">
                    <h4 className="font-heading text-xl font-semibold text-white mb-2" data-id="element-226">
                      Service Area
                    </h4>
                    <p className="font-body text-gray-400 text-lg" data-id="element-227">
                      Based in Bali, Indonesia
                      <br data-id="element-228" />
                      Serving clients nationwide
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6" data-id="element-229">
                  <div className="w-14 h-14 bg-navy-800 rounded-full flex items-center justify-center text-gold shrink-0 border border-navy-700" data-id="element-230">
                    <Clock size={24} data-id="element-231" />
                  </div>
                  <div data-id="element-232">
                    <h4 className="font-heading text-xl font-semibold text-white mb-2" data-id="element-233">
                      Office Hours
                    </h4>
                    <p className="font-body text-gray-400 text-lg" data-id="element-234">
                      Monday - Friday
                      <br data-id="element-235" />
                      9:00 AM - 6:00 PM (WITA)
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-navy-800 p-10 rounded-card border border-navy-700 shadow-card" data-id="element-236">
              <h3 className="font-heading text-2xl font-semibold text-white mb-8" data-id="element-237">
                Request a Consultation
              </h3>

              {isSuccess ? <div className="bg-green-900/30 border border-green-500/50 text-green-400 p-6 rounded-xl text-center" data-id="element-238">
                  <h4 className="font-heading text-xl font-semibold mb-2" data-id="element-239">
                    Message Sent Successfully
                  </h4>
                  <p className="font-body text-sm" data-id="element-240">
                    Thank you for reaching out. One of our consultants will
                    contact you shortly.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-241">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-242">
                    <div data-id="element-243">
                      <label htmlFor="name" className="block font-sub text-sm text-gray-400 mb-2" data-id="element-244">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full bg-navy-900 border border-navy-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors font-body" placeholder="John Doe" data-id="element-245" />
                    </div>
                    <div data-id="element-246">
                      <label htmlFor="phone" className="block font-sub text-sm text-gray-400 mb-2" data-id="element-247">
                        Phone / WhatsApp
                      </label>
                      <input type="tel" id="phone" name="phone" required value={formState.phone} onChange={handleChange} className="w-full bg-navy-900 border border-navy-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors font-body" placeholder="+62 812 3456 7890" data-id="element-248" />
                    </div>
                  </div>

                  <div data-id="element-249">
                    <label htmlFor="email" className="block font-sub text-sm text-gray-400 mb-2" data-id="element-250">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full bg-navy-900 border border-navy-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors font-body" placeholder="john@example.com" data-id="element-251" />
                  </div>

                  <div data-id="element-252">
                    <label htmlFor="service" className="block font-sub text-sm text-gray-400 mb-2" data-id="element-253">
                      Service of Interest
                    </label>
                    <select id="service" name="service" required value={formState.service} onChange={handleChange} className="w-full bg-navy-900 border border-navy-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors font-body appearance-none" data-id="element-254">
                      <option value="" disabled data-id="element-255">
                        Select a service
                      </option>
                      <option value="property" data-id="element-256">Property Management</option>
                      <option value="accounting" data-id="element-257">Accounting & Tax</option>
                      <option value="audit" data-id="element-258">Audit Services</option>
                      <option value="legal" data-id="element-259">
                        Legal & Company Establishment
                      </option>
                      <option value="visa" data-id="element-260">Visa & Expat Services</option>
                      <option value="other" data-id="element-261">Other Inquiry</option>
                    </select>
                  </div>

                  <div data-id="element-262">
                    <label htmlFor="message" className="block font-sub text-sm text-gray-400 mb-2" data-id="element-263">
                      Message
                    </label>
                    <textarea id="message" name="message" required rows={4} value={formState.message} onChange={handleChange} className="w-full bg-navy-900 border border-navy-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold transition-colors font-body resize-none" placeholder="Please describe your requirements..." data-id="element-264"></textarea>
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full bg-gold hover:bg-gold-light text-navy-900 font-sub font-semibold py-4 px-8 rounded-btn transition-all duration-300 shadow-gold hover:shadow-none text-sm uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-265">
                    {isSubmitting ? 'Sending...' : <>
                        Send Message <Send size={18} data-id="element-266" />
                      </>}
                  </button>
                </form>}
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}